module.exports = __webpack_public_path__ + "static/media/xmas-sm.665d0531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/xmas-sm.jpg
// module id = 175
// module chunks = 12